import React, { FunctionComponent } from 'react';

import { HomeFormValues, HomeFunnelState } from 'scenes/home/types';
import { SingleYesNoStep } from 'scenes/common/components/Steps';
import { getAddAdditionalPolicyHolder } from 'scenes/home/selectors';

export const QUESTION = 'Would you like to add an additional policy holder?';
const STATE_KEY = 'addAdditionalPolicyHolder';

type AddAdditionalPolicyHolderStepProps = {
  funnelState: HomeFunnelState;
  onNext: (values: HomeFormValues) => void;
};
const AddAdditionalPolicyHolderStep: FunctionComponent<AddAdditionalPolicyHolderStepProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={STATE_KEY}
    defaultStateValue={getAddAdditionalPolicyHolder(funnelState)}
    onNext={onNext}
  />
);

export default AddAdditionalPolicyHolderStep;
